﻿import dimbox from 'dimbox';

dimbox.setConfig({
    showDownloadButton: false,
    iframeTemplate: "<div class='dimbox-iframe-container'><iframe allow='autoplay; fullscreen' src='{{src}}?autoplay=1&playsinline=1' class='dimbox-iframe'></iframe></div>",
    onAfterOpen: function () {
        let $box = document.querySelector('.dimbox-inline-content > div');
        if ($box.id === 'newsletterBox') {
            $box.id = $box.id + "-copy";
            if (typeof initNewsLetter === 'function') {
                loadedWidgets.filter(x => x !== 'Crm/newsletter/apply');
                twwWidgets = twwWidgets.filter(obj => { return obj.widgetname !== 'Crm/newsletter/apply' });
                initNewsLetter('newsletterBox-copy');
            }
        } else {
            $box.removeAttribute('id');
        }
    }
});